// Module
var code = "<div class=\"audience-table-view-widget\">\n    <div class=\"insight-page modal-fadein tabs-container\">\n        <div class=\"left-aligned-title\">Audience Interest</div>\n        <div class=\"table-container\">\n            <quick-table></quick-table>\n        </div>\n    </div>\n</div>\n";
// Exports
module.exports = code;